const event = {
    onClickSeries: 'onClickSeries',
    onOverSeries: 'onOverSeries',
    onOutSeries: 'onOutSeries',
    onToggleHelp: 'onToggleHelp',
    onToggleZoom: 'onToggleZoom'
};

// emit[action]: launch actions from inside (renderer) or outside (chart component)
// on[action]: listener for actions: use from outside (chart component)
// onModule[action]: listener for actions: use from inside (renderer, tooltip)
export class ChartInteractions {
    constructor (component, chartDataHelper) {
        this.chartDataHelper = chartDataHelper;
        this.component = component;
    }

    // clickSeries
    emitClickSeries (series) {
        this.component.$emit(event.onClickSeries, this.chartDataHelper.type, series);
    }
    onClickSeries (callback) {
        this.component.$on(event.onClickSeries, callback);
    }
    onModuleClickSeries (type, callback) {
        this.component.$on(event.onClickSeries, (typeRef, args) => {
            (type === typeRef) && callback(args);
        });
    }
    // -----------

    // overSeries
    emitOverSeries (series) {
        this.component.$emit(event.onOverSeries, this.chartDataHelper.type, series);
    }
    onOverSeries (callback) {
        this.component.$on(event.onOverSeries, callback);
    }
    onModuleOverSeries (type, callback) {
        this.component.$on(event.onOverSeries, (typeRef, args) => {
            (type === typeRef) && callback(args);
        });
    }
    // ----------

    // outSeries
    emitOutSeries (series) {
        this.component.$emit(event.onOutSeries, this.chartDataHelper.type, series);
    }
    onOutSeries (callback) {
        this.component.$on(event.onOutSeries, callback);
    }
    onModuleOutSeries (type, callback) {
        this.component.$on(event.onOutSeries, (typeRef, args) => {
            (type === typeRef) && callback(args);
        });
    }
    // --------

    // toggle show/hide help
    emitToggleHelp (enabled) {
        this.component.$emit(event.onToggleHelp, this.chartDataHelper.type, enabled);
    }
    onToggleHelp (callback) {
        this.component.$on(event.onToggleHelp, callback);
    }
    onModuleToggleHelp (type, callback) {
        this.component.$on(event.onToggleHelp, (typeRef, args) => {
            (type === typeRef) && callback(args);
        });
    }
    // ---------

    // toggle zoom in/out
    emitToggleZoom (enabled) {
        this.component.$emit(event.onToggleZoom, this.chartDataHelper.type, enabled);
    }
    onToggleZoom (callback) {
        this.component.$on(event.onToggleZoom, callback);
    }
    onModuleToggleZoom (type, callback) {
        this.component.$on(event.onToggleZoom, (typeRef, args) => {
            (type === typeRef) && callback(args);
        });
    }
}
